export default __webpack_public_path__ + "images/3H.374f0b0.png";